import Vue from 'vue'
import main from './main.vue'

const MainConstructor = Vue.extend(main)

let instance

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(instance.$el)
}

/**
 *
 * @param options
 * @param newInstance 在不同的页面可能有不同形式的右键菜单，这些菜单没有任何关联，因此挂载时需要先清除它们
 * @returns {*}
 * @constructor
 */
const ContextMenu = function (options = {}, newInstance = false) {
  if (newInstance || !instance) {
    initInstance()
  }
  for (const key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key]
    }
  }
  return instance
}

ContextMenu.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default ContextMenu
export { ContextMenu }



// WEBPACK FOOTER //
// ./src/views/question-review/components/ContextMenu/src/main.js